import { IReduxStore } from "Redux/Store/IReduxStore";

export const getTagCount = (state: IReduxStore) =>
    state.tag.tag.maxCount;